import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

import Collection from '../Model/Collection';

import ItemTableRow from '../Components/ItemTableRow';
import OrganizationRequiringSubscriptionCard from '../Support/Components/OrganizationRequiringSubscriptionCard';
import OrganizationRequiringSubscriptionCollectionFields from '../Model/OrganizationRequiringSubscriptionCollectionFields';

import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';

import { NumberWithSeparators } from '../Util/NumberFormatting';
import {
  GetDateValue,
  GetBoolValue,
  GetUserValue,
} from '../Util/Properties';
import {
  GetSupportOrganizationDetailPath,
} from '../Util/PathHelper';
import {
  GetSupportOrganizationsRequiringSubscriptionPathForApi,
} from '../Util/api';

export class SupportOrganizationsRequiringSubscription_Collection extends Collection {
  constructor(props, onSetState, onApiError, isWorkspace, isProjects) {
    super(props, onSetState, onApiError, isWorkspace, isProjects);

    this.PageTitle = "Organizations Requiring Subscription";
    this.ContentUri = GetSupportOrganizationsRequiringSubscriptionPathForApi();
    this.CollectionName = "SupportOrganizationsRequiringSubscription";
    this.ItemsName = "Organizations";
    this.ItemName = "Organization";
    this.DefaultViewType = "List";
  }

  HandleGetCollectionFieldsPromise = () => Promise.resolve(OrganizationRequiringSubscriptionCollectionFields);

  HandleGetHeadCells = (items, sensitiveFields) => [
    { id: 'Name', numeric: false, label: 'Name' },
    { id: 'CreatedUser', numeric: false, label: 'Creating User' },
    // { id: 'Firestore', numeric: false, label: 'Firestore' },
    // { id: 'BucketName', numeric: false, label: 'Cloud Storage' },
    // { id: 'SearchIndexID', numeric: false, label: 'ElasticSearch' },
    { id: 'SubscriptionExpiration', numeric: false, label: 'Expiration' },
    { id: 'SubscriptionFreeUsers', numeric: true, label: 'Free Members Allowed' },
    { id: 'UniqueFreeOrganizationMembers', numeric: true, label: 'Free Members Used' },
    { id: 'UniqueBillableOrganizationMembers', numeric: true, label: 'Billable Members' },
    { id: 'UniqueNonReadOnlyOrganizationMembers', numeric: true, label: 'Total Members' },
    { id: 'SubscriptionActive', numeric: false, label: 'Active Subscription' },
    { id: 'SubscriptionPlanTitle', numeric: false, label: 'Plan Title' },
    { id: 'SubscriptionRecurringAmount', numeric: true, label: 'Recurring Amount' },
    { id: 'CreatedOn', numeric: false, label: 'Created On' },
    { id: 'Disabled', numeric: false, label: 'Disabled?' },
    // { id: 'PurgeDate', numeric: false, label: 'Purge Date?' },
  ];

  getPurgeMarkedText = (organization, classes, includeLabel) => {
    return (organization.IsMarkedForPurge)
      ? (
        <Typography style={{color:red[500]}}>
          <span className={classes.metadataName}>{`${(includeLabel) ? "Removal on " : ""}${GetDateValue(organization.PurgeDate)}`}</span>
        </Typography>
      ) : null;
  }

  getDisabledText = (organization, classes) => {
    return (organization.Disabled)
      ? (
        <Typography style={{color:red[500]}}>
          <span className={classes.metadataName}>DISABLED</span>
        </Typography>
      ) : null;
  }

  HandleGetCardGridItems = (items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length) 
      ? items
        .map(i => {
          return (
            <Grid item key={i.ID} sm={12} md={6} lg={4} xl={3} className={classes.cardGridItem}>
              <OrganizationRequiringSubscriptionCard
                Organization={i}
                // PurgeMarkedText={this.getPurgeMarkedText(i, classes, true)}
                DisabledText={this.getDisabledText(i, classes)}
                onCardAction={() => this.handleRouteToOrganizationDetail(i)}
              />
            </Grid>
          );
        }) 
      : [];
  }

  HandleGetTableRows = (headCells, items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length)
      ? items
        .map(i => {
          const isExpired = new Date(i.SubscriptionExpiration) < new Date();
          return (
            <ItemTableRow key={`k_${i.ID}`}
              onItemClick={() => this.handleRouteToOrganizationDetail(i)}
            >
              <TableCell className={classes.tableCell_FirstCell} padding="checkbox">
                <Checkbox
                  style={{
                    visibility: "hidden",
                  }}
                  color="secondary"
                />
              </TableCell>
              <TableCell className={classes.tableCell} component="th" id={`label_${i.ID}`} scope="row" padding="none">
                {i.Name}
              </TableCell>
              <TableCell className={classes.tableCell}>{GetUserValue(i.CreatedByUserEmail, i.CreatedByUserName)}</TableCell>
              {/*<TableCell className={classes.tableCell}>{i.ID}</TableCell>
              <TableCell className={classes.tableCell}>{i.BucketName}</TableCell>
              <TableCell className={classes.tableCell}>{i.SearchIndexID}</TableCell>*/}
              <TableCell className={classes.tableCell} style={{color:(isExpired) ? red[500] : green[500]}}>{GetDateValue(i.SubscriptionExpiration)}</TableCell>
              <TableCell className={classes.tableCell} align="right">{NumberWithSeparators(i.SubscriptionFreeUsers)}</TableCell>
              <TableCell className={classes.tableCell} align="right">{NumberWithSeparators(i.UniqueFreeOrganizationMembers)}</TableCell>
              <TableCell className={classes.tableCell} align="right">{NumberWithSeparators(i.UniqueBillableOrganizationMembers)}</TableCell>
              <TableCell className={classes.tableCell} align="right">{NumberWithSeparators(i.UniqueNonReadOnlyOrganizationMembers)}</TableCell>
              <TableCell className={classes.tableCell}>{GetBoolValue(i.PaymentPlanId !== "" && !i.SubscriptionCanceled && !isExpired)}</TableCell>
              <TableCell className={classes.tableCell}>{i.PaymentPlanTitle}</TableCell>
              <TableCell className={classes.tableCell} align="right">{(i.PaymentRecurringAmount) ? `$${NumberWithSeparators(i.PaymentRecurringAmount)}` : null}</TableCell>
              <TableCell className={classes.tableCell}>{GetDateValue(i.CreatedOn)}</TableCell>
              <TableCell className={classes.tableCell}>{this.getDisabledText(i, classes)}</TableCell>
              {/*<TableCell className={classes.tableCell}>{this.getPurgeMarkedText(i, classes)}</TableCell>*/}
            </ItemTableRow>
          );
        }) 
      : [];
  }

  handleRouteToOrganizationDetail = organization => {
    // this.props.history.push(GetSupportOrganizationDetailPath(organization.ID));
    window.open(GetSupportOrganizationDetailPath(organization.ID), "n1_supportOrganization");
  }
}